function customPopup(place, lang) {
	return `
		${place.img !== false ? `
			<div class="popup__img">
				<img src="assets/images/thumbs/${currentHotel}/${place.id}.jpg">
			</div>
		` : ``}
		<div class="popup__content">
			<h1 class="popup__title">${place.lang[lang].name}</h1>
			${place.lang[lang].info ? `<p class="popup__info">${place.lang[lang].info}</p>` : ``}
			${place.img !== false ? `<button class="popup__btn" data-placeid="${place.id}" data-imgw="${place.img ? place.img.w : `1200`}" data-imgh="${place.img ? place.img.h: `900`}">${lang === "esp" ? "Ver imagen" : "View Photo"}</button>` : ""}
		</div>
	`
};

let customOptions = {
	className: "popup"
};

if (MobDet) {
	customOptions.maxWidth = 250
	customOptions.minWidth = 250
} else {
	customOptions.maxWidth = 380
	customOptions.minWidth = 380
}

export {customPopup, customOptions}